import HomeFloorBox from './home-floor-box';
import React, {useMemo, useState} from 'react';
import MoreBtn from './home-floor-more-btn';
import {Image} from '@/components-v2';
import {ReactComponent as RoundWhiteGradient} from '../../assets/icon/round-white-gradient.svg';
import {formatDate, getUrlParams, goTo, toPriceStr} from '@/utils';
import {useTranslation} from 'react-i18next';
import GameContainer from './game-container';
import {HomeGameCardItem} from '@/pages/home/home.type';

const ColorList = [
  '#009DE2',
  '#7044E9',
  '#EA3C15',
  '#F5B000',
  '#F58400',
  '#F55800',
  '#683A20',
  '#02A613',
  '#D63C86',
  '#278CE8',
  '#9B29DE',
  '#00A98A',
];

type GameItem = {
  lottoInfo?: {
    lotteryId: string;
    wonAmount: `${number}`;
    gameType: 'quick' | undefined;
  };
  otherInfo?: {
    roundNo?: string;
    stopTime?: `${number}`;
    cycle?: `${number}`;
  };
} & HomeGameCardItem;

const mixLottoCardStyle = {
  minWidth: '25%',
};

const HomeFloorMixLotto = ({
  name,
  id,
  games: _games,
  categoryPic,
}: {
  name: string;
  id: string;
  games: GameItem[];
  categoryPic?: string;
}) => {
  const [more, setMore] = useState(true);
  const {t} = useTranslation();
  const games = useMemo(() => {
    const currentTime = new Date().getTime() / 1000;
    const sortedGames = [
      ..._games
        .map(v => {
          v.lottoInfo = getUrlParams(v.gameUrl) as GameItem['lottoInfo'];
          v.otherInfo = getUrlParams(v.otherParams) as GameItem['otherInfo'];
          return v;
        })
        .sort((a, b) => {
          // quick放最前面
          // 结束的放在最后面
          // 剩余的按照顺序排列
          if (
            a.lottoInfo?.gameType === 'quick' &&
            b.lottoInfo?.gameType === 'quick'
          ) {
            return 0;
          }
          if (a.lottoInfo?.gameType === 'quick') {
            return -1;
          }
          if (b.lottoInfo?.gameType === 'quick') {
            return 1;
          }
          const aTime = Number(a.otherInfo!.stopTime);
          const bTime = Number(b.otherInfo!.stopTime);
          if (aTime < currentTime && bTime < currentTime) {
            return 0;
          }
          if (aTime < currentTime) {
            return 1;
          }
          if (bTime < currentTime) {
            return -1;
          }
          return aTime - bTime;
        }),
    ] as (Required<GameItem> | null)[];
    const remainder = sortedGames.length % 3;
    if (remainder === 1) {
      sortedGames.push(...[null, null]);
    } else if (remainder === 2) {
      sortedGames.push(null);
    }
    return sortedGames;
  }, [_games]);
  const goGame = (v: GameItem) => {
    const lottoInfo = getUrlParams(v.gameUrl) as {
      lotteryId: string;
      wonAmount: `${number}`;
      gameType?: string;
    };
    goTo('MixLottery', {
      lotteryID: lottoInfo.lotteryId,
      lotteryName: v.name,
      isQuick: lottoInfo.gameType === 'quick' ? '1' : '0',
    });
  };
  return (
    <HomeFloorBox
      gameType="mixLotto"
      categoryPic={categoryPic}
      id={id}
      name={name}
      rightNode={<MoreBtn expend={more} onClick={() => setMore(!more)} />}>
      {(more ? games : games.slice(0, 6)).map((item, index) => {
        if (!item) {
          return <div className="flex-1 p-3 pt-1" key={index} />;
        }
        const isClosed = item.lottoInfo.gameType
          ? false
          : parseInt(item.otherInfo.stopTime || '0', 10) * 1000 <
            new Date().getTime();
        return (
          <GameContainer
            gameName={item.name}
            closed={isClosed}
            key={index}
            style={{
              ...mixLottoCardStyle,
              backgroundColor: ColorList[index % 12],
            }}
            className={
              'rounded-lg p-3 pt-1 h-[8.75rem] flex-1 flex flex-col items-center relative text-white font-black' +
              (item.lottoInfo.gameType ? ' justify-center' : '')
            }
            onClick={() => {
              goGame(item);
            }}>
            <RoundWhiteGradient
              className={`absolute ${
                item.lottoInfo.gameType ? '' : '-top-1'
              } size-28`}
            />
            <Image
              src={isClosed ? item.otherUrl || item.gamePic : item.gamePic}
              alt={item.name}
              className="size-16"
            />
            <span className="text-base din mb-1 leading-4">
              {toPriceStr(parseInt(item.lottoInfo.wonAmount, 10), {fixed: 0})}
            </span>
            <span className="text-9 mb-1.5 din">JACKPOT</span>
            {item.lottoInfo.gameType ? (
              <div className="text-9 font-bold text-center flex flex-col">
                <span>{t('home.label.type')}</span>
                <span>
                  {item.otherInfo.cycle} {t('home.label.minutes')}
                </span>
              </div>
            ) : (
              <div className="text-9 font-bold text-center flex flex-col">
                <span>{t('home.label.nextDraw')}</span>
                <span>
                  {formatDate(
                    parseInt(item.otherInfo.stopTime || '0', 10),
                    'Mon ddsuffix HH:mm',
                  )}
                </span>
              </div>
            )}
          </GameContainer>
        );
      })}
    </HomeFloorBox>
  );
};

export default HomeFloorMixLotto;
